import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withSnackbar } from "notistack";
import Grid from "@material-ui/core/Grid";
import axios from "axios";
import {
  instance,
  GLOBAL_TOKEN,
  downloadFile,
} from "../../../Actions/AxiosInstance";
import {
  updateAuthentication,
  VerifyAccountApi,
} from "../../../Actions/AuthenticationAction";
import Configs from "../../../Constants/Configs";
import Image from "../../../Assets/Svg/Downloadcloudfile.svg";
import Image1 from "../../../Assets/Images/trial-activate.svg";
import sumHRLogo from "../../../Assets/Images/sumHR-logo.svg";
import "../VerifyAccount/index.css";

class DownloadPayslip extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      msg: "",
      flag: false,
      issuccess: false,
      loading: false,
    };
    // this.downloadFile = this.downloadFile.bind(this);
  }

  componentDidMount() {}

  showLoader() {
    return (
      <div
        className="pre-loader"
        style={{
          marginLeft: "50%",
          transform: "translateX(-50%)",
        }}
      >
        Downloading...
      </div>
    );
  }

  componentWillMount() {
    const isloggedin = localStorage.getItem("loggedin");
    console.log("isloggedin: ", isloggedin);
    if (isloggedin == null) {
      const employeeLink = `${window.location.origin}/login`;
      setTimeout(() => {
        window.open(employeeLink, "_self");
      }, 100);
    } else {
      this.setState({ loading: true }, () => {
        const ConvertHeadersForBackend1 = (headers) => {
          headers.Authorization = GLOBAL_TOKEN;
          headers["Content-Type"] = "application/json";
          return headers;
        };

        const instance1 = axios.create({
          baseURL: Configs.API_URL,
          transformRequest: [
            // eslint-disable-next-line no-unused-vars
            (data, headers) => {
              headers = ConvertHeadersForBackend1(headers);
              return JSON.stringify(data);
            },
          ],
        });
        instance1
          .get(
            `upload/getfilenameurl/${this.props.match.params.filename}/${
              this.props.match.params.url
            }/${this.props.match.params.isdb ? "isdb" : ""}`,
          )
          .then((result) => {
            downloadFile(
              result.data.result[0].filepath,
              result.data.result[0].filename,
            );
            this.setState(
              { loading: false },
              //     , () => this.props.enqueueSnackbar("Downloaded successfully", {
              //     variant: "success",
              // })
            );

            setTimeout(() => {
              this.props.history.push("/desk");
            }, 100);
            // const employeeLink = `${window.location.origin}/desk`;
            // setTimeout(() => {
            //     window.open(employeeLink, "_self");
            // }, 100);
          })
          .catch((error) => {
            const CommonError = error.response
              ? error.response.data.error.message
              : error.message;
            this.props.enqueueSnackbar(CommonError, { variant: "error" });
          });
      });
    }
  }

  // downloadFile(url) {
  //     instance.get(`upload/getfilenameurl/${url}`).then((result) => {
  //         downloadFile(this.props.match.params.url, "downloaddata");
  //             this.props.enqueueSnackbar("Downloaded successfully", {
  //                 variant: "success",
  //             });

  //             this.props.history.push("/desk");
  //       }).catch((error) => {
  //         const CommonError = error.response
  //           ? error.response.data.error.message
  //           : error.message;
  //         this.props.enqueueSnackbar(CommonError, { variant: 'error' });
  //       });
  // }

  render() {
    return (
      <Grid className="outer-wrapper-come">
        <div className="inner-wrapper-come">
          <div style={{ textAlign: "center" }}>
            <img className="img" src={Image} />
            <p>Downloading...</p>
          </div>
        </div>
      </Grid>
    );
  }
}

const mapStateToProps = (state) => ({
  AuthenticationAction: state.AuthenticationAction,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateAuthentication,
      VerifyAccountApi: (data) => VerifyAccountApi(data),
    },
    dispatch,
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withSnackbar(DownloadPayslip));
